import Image from 'next/image'
import Link from 'next/link'
import { useState } from 'react'

import { Breadcrumbs } from '@/components/atomic/Breadcrumbs'
import { PageContainer } from '@/components/atomic/PageContainer'
import { PageMetaData } from '@/components/atomic/PageMetaData'
import { ChatWidget } from '@/components/styleguide/ChatWidget'
import { Header } from '@/components/styleguide/Header'
import { constants } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'

export default function GuidesPage() {
  const [breadcrumbs] = useState([
    {
      title: 'Home',
      slug: ROUTES.homePage.url,
    },
    {
      title: `Leasing Guides`,
      slug: null,
    },
  ])

  return (
    <>
      <PageMetaData
        title="Leasing Guides | LeaseLoco"
        pageTitle="Leasing Guides | LeaseLoco"
        description="Thinking of leasing a car but have some questions? If so, our leasing guides will help answer any queries you may have."
        pageUrl={ROUTES.guidesPage.url}
      />
      <ChatWidget />
      <Header backgroundColor="white" />
      <PageContainer containerClass="container--guides">
        <div className="row">
          <div className="col-12 text-left">
            <Breadcrumbs breadcrumbs={breadcrumbs} />
            <h1>Leasing Guides</h1>
          </div>
        </div>
        <div className="row">
          <div className="col-6 col-md-6">
            <div className="row">
              <div className="col-12 col-lg-12">
                <div className="guides__card">
                  <Link href="/guides/personal-car-leasing">
                    <a>
                      <Image
                        src={`https://vehicle.images.leaseloco.com/extra-large/Audi/A6%20Saloon/Audi_A6%20Saloon_2.jpg`}
                        alt="An Audi A6 on the road"
                        width="540"
                        height="360"
                      />
                      <div className="guides__card__content">
                        <h2>Personal Car Leasing</h2>
                      </div>
                      <div className="guides__card__cta">
                        <button
                          type="button"
                          className="button-cta">
                          Find out more&nbsp;
                          <span className="filter-arrow">
                            <Image
                              src={`${constants.imageHost.assets}/icons/arrow-right.png`}
                              alt=""
                              height="16"
                              width="8"
                            />
                          </span>
                        </button>
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
              <div className="col-12 col-lg-6 d-block d-lg-none">
                <div className="guides__card">
                  <Link href="/guides/business-car-leasing">
                    <a>
                      <Image
                        src={`${constants.imageHost.assets}/general/car-leasing-1.jpg`}
                        alt="A person holding a key in front of a car"
                        width="255"
                        height="170"
                      />
                      <div className="guides__card__content">
                        <h2>Business Car Leasing</h2>
                      </div>
                      <div className="guides__card__cta">
                        <button
                          type="button"
                          className="button-cta">
                          Find out more&nbsp;
                          <span className="filter-arrow">
                            <Image
                              src={`${constants.imageHost.assets}/icons/arrow-right.png`}
                              alt=""
                              height="16"
                              width="8"
                            />
                          </span>
                        </button>
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-6 col-md-6">
            <div className="row">
              <div className="col-12 col-lg-6">
                <div className="guides__card">
                  <Link href="/guides/contracts-and-finance">
                    <a>
                      <Image
                        src={`${constants.imageHost.assets}/general/car-leasing-2.jpg`}
                        alt="A contract and car key"
                        width="255"
                        height="170"
                      />
                      <div className="guides__card__content">
                        <h2>Contracts &amp; Finance</h2>
                      </div>
                      <div className="guides__card__cta">
                        <button
                          type="button"
                          className="button-cta">
                          Find out more&nbsp;
                          <span className="filter-arrow">
                            <Image
                              src={`${constants.imageHost.assets}/icons/arrow-right.png`}
                              alt=""
                              height="16"
                              width="8"
                            />
                          </span>
                        </button>
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
              <div className="col-12 col-lg-6 d-none d-lg-block">
                <div className="guides__card">
                  <Link href="/guides/business-car-leasing">
                    <a>
                      <Image
                        src={`${constants.imageHost.assets}/general/car-leasing-1.jpg`}
                        alt="A person holding a key in front of a car"
                        width="255"
                        height="170"
                      />
                      <div className="guides__card__content">
                        <h2>Business Car Leasing</h2>
                      </div>
                      <div className="guides__card__cta">
                        <button
                          type="button"
                          className="button-cta">
                          Find out more&nbsp;
                          <span className="filter-arrow">
                            <Image
                              src={`${constants.imageHost.assets}/icons/arrow-right.png`}
                              alt=""
                              height="16"
                              width="8"
                            />
                          </span>
                        </button>
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="guides__card guides__card--alternative">
                  <Link href={ROUTES.faqsPage.url}>
                    <a>
                      <div className="guides__card__content">
                        <h2>Frequently Asked Questions</h2>
                        <p>Our experts answer all your questions about car and van leasing.</p>
                      </div>
                      <div className="guides__card__cta">
                        <button
                          type="button"
                          className="button-cta">
                          Find out more&nbsp;
                          <span className="filter-arrow">
                            <Image
                              src={`${constants.imageHost.assets}/icons/arrow-right.png`}
                              alt=""
                              height="16"
                              width="8"
                            />
                          </span>
                        </button>
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 col-lg-6">
            <div className="row">
              <div className="col-6 col-md-6">
                <div className="guides__card">
                  <Link href="/guides/hybrid-and-electric-leasing">
                    <a>
                      <Image
                        src={`${constants.imageHost.assets}/general/car-leasing-4.jpg`}
                        alt="A close up of an electric car charging port"
                        width="255"
                        height="170"
                      />
                      <div className="guides__card__content">
                        <h2>Hybrid &amp; Electric Leasing</h2>
                      </div>
                      <div className="guides__card__cta">
                        <button
                          type="button"
                          className="button-cta">
                          Find out more&nbsp;
                          <span className="filter-arrow">
                            <Image
                              src={`${constants.imageHost.assets}/icons/arrow-right.png`}
                              alt=""
                              height="16"
                              width="8"
                            />
                          </span>
                        </button>
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
              <div className="col-6 col-md-6">
                <div className="guides__card">
                  <Link href="/guides/van-leasing-guide">
                    <a>
                      <Image
                        src={`${constants.imageHost.assets}/general/car-leasing-5.jpg`}
                        alt="A collection of white vans"
                        width="255"
                        height="170"
                      />
                      <div className="guides__card__content">
                        <h2>Van Leasing</h2>
                      </div>
                      <div className="guides__card__cta">
                        <button
                          type="button"
                          className="button-cta">
                          Find out more&nbsp;
                          <span className="filter-arrow">
                            <Image
                              src={`${constants.imageHost.assets}/icons/arrow-right.png`}
                              alt=""
                              height="16"
                              width="8"
                            />
                          </span>
                        </button>
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-6 col-lg-12">
                <div className="guides__card guides__card--alternative secondary">
                  <Link href={ROUTES.blogPage.url}>
                    <a>
                      <div className="guides__card__content">
                        <h2>Blogs</h2>
                        <p>
                          The latest car industry news and updates with added insight from our
                          leasing experts.
                        </p>
                      </div>
                      <div className="guides__card__cta">
                        <button
                          type="button"
                          className="button-cta">
                          Find out more&nbsp;
                          <span className="filter-arrow">
                            <Image
                              src={`${constants.imageHost.assets}/icons/arrow-right.png`}
                              alt=""
                              height="16"
                              width="8"
                            />
                          </span>
                        </button>
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
              <div className="col-6 d-lg-none">
                <div className="guides__card">
                  <Link href="/guides/leasing-with-leaseloco">
                    <a>
                      <Image
                        src={`${constants.imageHost.assets}/general/car-leasing-3.jpg`}
                        alt="A person holding a key inside a car"
                        width="600"
                        height="400"
                      />
                      <div className="guides__card__content">
                        <h2>Leasing With LeaseLoco</h2>
                      </div>
                      <div className="guides__card__cta">
                        <button
                          type="button"
                          className="button-cta">
                          Find out more&nbsp;
                          <span className="filter-arrow">
                            <Image
                              src={`${constants.imageHost.assets}/icons/arrow-right.png`}
                              alt=""
                              height="16"
                              width="8"
                            />
                          </span>
                        </button>
                      </div>
                    </a>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 col-md-6 d-none d-lg-block">
            <div className="guides__card">
              <Link href="/guides/leasing-with-leaseloco">
                <a>
                  <Image
                    src={`${constants.imageHost.assets}/general/car-leasing-3.jpg`}
                    alt="A person holding a key inside a car"
                    width="600"
                    height="400"
                  />
                  <div className="guides__card__content">
                    <h2>Leasing With LeaseLoco</h2>
                  </div>
                  <div className="guides__card__cta">
                    <button
                      type="button"
                      className="button-cta">
                      Find out more&nbsp;
                      <span className="filter-arrow">
                        <Image
                          src={`${constants.imageHost.assets}/icons/arrow-right.png`}
                          alt=""
                          height="16"
                          width="8"
                        />
                      </span>
                    </button>
                  </div>
                </a>
              </Link>
            </div>
          </div>
        </div>
      </PageContainer>
    </>
  )
}
